<template>
  <div class="img-ppt">
    <div class="img-ppt-btn-close" @click="$emit('close')">
      <v-icon icon="mdi-window-close" size="24" color="#fff" />
    </div>
    <div class="img-ppt-thumb-box" ref="thumbBox">
      <ul ref="thumbScroll">
        <li 
          v-for="(item, index) in files" 
          :key="index" 
          :class="{'active': index === activeIndex}"
          @click="changeImg(index)"
        >
          <v-img cover :src="item.file + '?x-oss-process=image/resize,l_300'" />
        </li>
      </ul>
      <div class="img-ppt-btn-cover img-ppt-btn-prev" @click="setPage(-1)">
        <v-icon icon="mdi-chevron-up" size="38" color="#fff"></v-icon>
      </div>
      <div class="img-ppt-btn-cover img-ppt-btn-next" @click="setPage(1)">
        <v-icon icon="mdi-chevron-down" size="38" color="#fff"></v-icon>
      </div>
    </div>
    <div class="img-ppt-big-box">
      <v-img :src="files[activeIndex].file" />
    </div>
  </div>
</template>

<script setup>
const { $multiPlatform } = useNuxtApp();
const primaryColor = $multiPlatform.primaryColor;

const props = defineProps({
  // 图片列表
  files: {
    type: Array,
    default: () => []
  },
  // 初始显示图片索引
  currentIndex: {
    type: Number,
    default: 0
  }
})

const activeIndex = ref(props.currentIndex)
const thumbBox = ref(null)
const thumbScroll = ref(null)

watch(activeIndex, () => {
  // 每个图片的高度+间距为110px
  const height = 110
  const num = Math.floor(thumbBox.value?.offsetHeight / height) - 2
  if(activeIndex.value < num) {
    thumbScroll.value.style.transform = `translateY(0px)`
  } else {
    thumbScroll.value.style.transform = `translateY(-${(activeIndex.value - num) * height}px)`
  }
})

function changeImg(index) {
  activeIndex.value = index
}

function setPage(step) {
  const len = props.files.length
  activeIndex.value += step
  if (activeIndex.value < 0) {
    activeIndex.value = len - 1
  }
  if (activeIndex.value >= len) {
    activeIndex.value = 0
  }
}

onMounted(() => {
  document.body.style.overflow = 'hidden'
  document.body.style.height = '100vh'
})

onUnmounted(() => {
  document.body.style = ''
})
</script>

<style lang="scss">
.img-ppt {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(30px);
  z-index: 9999999999;
  --primary-color: v-bind(primaryColor);
  .img-ppt-btn-close {
    position: absolute;
    z-index: 1;
    top: 40px;
    right: 40px;
    width: 40px;
    height: 40px;
    color: #fff;
    background-color: #606266;
    opacity: 0.8;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    cursor: pointer;
  }
  .img-ppt-btn-cover {
    position: absolute;
    left: 0;
    width: 100%;
    height: 40px;
    background-color: rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color 0.3s ease;
    &.img-ppt-btn-prev {
      top: 0;
    }
    &.img-ppt-btn-next {
      bottom: 0;
    }
    &:hover {
      background-color: rgba(0, 0, 0, .4);
    }
  }
  .img-ppt-thumb-box {
    position: absolute;
    padding: 40px 20px;
    background-color: rgba(0, 0, 0, 0.1);
    left: 0px;
    top: 0px;
    height: 100%;
    width: 140px;
    overflow: hidden;
    ul {
      transition: transform 0.3s ease;
      li {
        width: 100px;
        height: 100px;
        margin: 10px 0;
        background-color: #fff;
        border-radius: 2px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border: 3px solid #fff;
        &.active {
          border-color: var(--primary-color);
          cursor: default;
        }
      }
    }
  }
  .img-ppt-big-box {
    position: absolute;
    left: 160px;
    top: 20px;
    right: 20px;
    bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      object-fit: scale-down !important;
    }
  }
}
</style>